export default {"src":"/_next/static/media/network-services.6db515b7.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};